import { atom } from "recoil";

export const addStateMGA = atom({
  key: "addStateMGA ",
  default: false,
});
export const editStateMGA = atom({
  key: "editStateMGA",
  default: false,
});
export const selectedMGA = atom({
  key: "selectedMGA",
  default: [],
});

export const selectedRowsStateMGA = atom({
  key: "selectedRowsStateMGA",
  default: [],
});

export const setFilterTextMGA = atom({
  key: "setFilterTextMGA",
  default: "",
});
